import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminDeleteTranslationContentMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminDeleteTranslationContentMutationResultFragment, AdminDeleteTranslationContentMutationParams } from '@docpace/admin-graphql'

const typedAdminDeleteTranslationContentMutationDocument = AdminDeleteTranslationContentMutationDocument as TypedDocumentNode<AdminDeleteTranslationContentMutationResultFragment, Partial<AdminDeleteTranslationContentMutationParams>>

export function useAdminDeleteTranslationContentMutation(opts?: useMutation.Options<AdminDeleteTranslationContentMutationResultFragment, Partial<AdminDeleteTranslationContentMutationParams>>){
    return useMutation(typedAdminDeleteTranslationContentMutationDocument, opts)
}
